(function () {
  const translateButton = () => {
    document.querySelectorAll('.Evey__Premium__ShowMoreButton').forEach(button => {
      if (button.textContent.trim() === 'Show More Events') {
        button.textContent = "Plus d’évènements";
        button.setAttribute('aria-label', "Plus d’évènements");
      }
    });
  };
  translateButton();
  const observer = new MutationObserver(translateButton);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();